import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Hinjewaditomumbaicabs() {



const cardData = {
  keyword: " Hinjewadi to Mumbai Cabs ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Hinjewadi to Mumbai cab services, making your intercity travel seamless and stress-free. Whether you are traveling for business, airport transfers, family trips, or leisure, our professional drivers and well-maintained vehicles ensure a smooth journey from Hinjewadi to Mumbai. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for individuals, families, and corporate travelers. With easy online booking, punctual pickups from any location in Hinjewadi, and 24/7 customer support, Velocity Cab is your trusted choice for cab travel to Mumbai.",

topPlaces: [
   {
    title: "Madh Island",
    description: "Madh Island is a peaceful coastal destination known for its quiet beaches, fishing villages, and scenic surroundings. Renting an Innova Crysta in Pune provides a comfortable journey for travelers looking to escape the city's hustle and bustle. The island is ideal for weekend getaways, beach walks, photography, and enjoying fresh seafood."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
    description: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya is one of India's premier museums, housing remarkable collections of art, sculptures, manuscripts, and historical artifacts. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this iconic museum and discover India's rich cultural and artistic heritage in a beautifully preserved historic building."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is an architectural masterpiece dedicated to meditation and inner peace. Visitors traveling with an Innova Crysta on rent in Pune can enjoy a scenic drive to this magnificent monument near Gorai. The peaceful atmosphere, meditation center, and impressive golden dome make it one of Mumbai's most unique attractions."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also called Castella de Aguada, is a historic Portuguese fort offering stunning views of the Arabian Sea and Bandra-Worli Sea Link. Travelers renting an Innova Crysta in Pune can comfortably visit this heritage site, explore its ancient walls, and enjoy excellent photography opportunities overlooking Mumbai's coastline."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a picturesque destination surrounded by gardens, cafés, and modern city landmarks. Booking an Innova Crysta on rent in Pune allows families and groups to enjoy a relaxing road trip before spending time boating, walking along the lakeside, or dining at nearby restaurants. It is an excellent place to unwind during a Mumbai visit."
  }
  , {
    title: "Kanheri Caves",
    description: "Kanheri Caves are ancient Buddhist rock-cut caves located within Sanjay Gandhi National Park in Mumbai. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable road trip to explore these centuries-old caves, meditation halls, sculptures, and inscriptions. Surrounded by lush greenery, the site is perfect for history enthusiasts, photographers, and nature lovers seeking a unique cultural experience."
  },
  {
    title: "Girgaon Chowpatty",
    description: "Girgaon Chowpatty is one of Mumbai's most famous beaches, known for its lively atmosphere, delicious street food, and beautiful sunsets. Renting an Innova Crysta in Pune ensures a relaxing journey for families and groups planning a memorable beach outing. Visitors can enjoy local snacks, evening walks, and spectacular views of the Arabian Sea."
  },
  {
    title: "Mount Mary Basilica",
    description: "Mount Mary Basilica in Bandra is one of Mumbai's most visited churches, attracting thousands of devotees and tourists every year. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this beautiful hilltop church while enjoying peaceful surroundings and panoramic views of the Arabian Sea. The church is especially popular during the annual Mount Mary Fair."
  },
  {
    title: "Taraporewala Aquarium",
    description: "Taraporewala Aquarium is one of India's oldest public aquariums and features an impressive collection of freshwater and marine species. Visitors hiring an Innova Crysta on rent in Pune can conveniently explore colorful fish, exotic aquatic life, and interactive exhibits. It is an excellent attraction for children, families, and marine life enthusiasts."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a scenic waterfront promenade offering breathtaking views of the Arabian Sea and the iconic Bandra-Worli Sea Link. Travelers booking an Innova Crysta on rent in Pune can relax by the coastline, enjoy fresh sea breezes, and capture beautiful sunset photographs. It is a perfect destination for evening outings and peaceful walks."
  },

],



services: [
{
name: "Hinjewadi To Borivali Taxi",
description: "Hinjewadi to Borivali taxi service provides reliable transportation between Pune’s IT hub Hinjewadi and Borivali in Mumbai. Professional drivers ensure safe and comfortable travel through the Mumbai–Pune Expressway. Vehicles are well maintained and suitable for business travel, airport transfers, and family trips. Pickup services are available from offices, tech parks, hotels, and residential societies in Hinjewadi. Flexible booking options allow easy cab reservations."
},
{
name: "Hinjewadi To Santacruz Taxi",
description: "Hinjewadi to Santacruz taxi service offers convenient intercity transportation for passengers traveling between Pune and Santacruz in Mumbai. Comfortable vehicles with professional drivers ensure safe highway journeys. Pickup services are available from homes, offices, and IT parks in Hinjewadi. Ideal for business travelers, tourists, and airport passengers. Flexible booking options allow convenient ride reservations."
},
{
name: "Hinjewadi To Andheri Taxi",
description: "Hinjewadi to Andheri taxi service provides dependable transportation between Pune’s IT corridor and Mumbai’s Andheri suburb. Vehicles are comfortable and suitable for long-distance highway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, and tech parks in Hinjewadi. Flexible booking options allow quick cab reservations."
},
{
name: "Hinjewadi To Mumbai Airport Taxi",
description: "Hinjewadi to Mumbai Airport taxi service offers reliable airport transportation for passengers traveling to Chhatrapati Shivaji Maharaj International Airport. Vehicles provide comfortable seating and luggage space suitable for airport journeys. Professional drivers ensure punctual pickup and safe driving through the expressway. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Hinjewadi To International Airport Cab",
description: "Hinjewadi to international airport cab service provides dependable transportation for travelers heading to Mumbai’s international airport terminal. Comfortable vehicles with professional drivers ensure safe highway travel and timely arrival. Pickup services are available from IT parks, homes, and offices across Hinjewadi. Flexible booking options allow easy airport cab reservations."
},
{
name: "Hinjewadi To Airport Fare",
description: "Hinjewadi to airport fare services provide transparent pricing for passengers traveling from Hinjewadi to Mumbai Airport. Travelers can estimate fare based on vehicle type such as sedan, Ertiga, or Innova. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow convenient travel planning."
},
{
name: "Hinjewadi To Mumbai Drop Taxi Fare",
description: "Hinjewadi to Mumbai drop taxi fare services provide cost estimates for one-way travel from Hinjewadi to Mumbai city. Vehicles are comfortable and suitable for expressway journeys with professional drivers ensuring safe travel. Pickup services are available from homes, offices, and IT companies across Hinjewadi. Flexible booking options allow easy cab reservations."
},
{
name: "Hinjewadi To Mumbai Central Taxi Fare",
description: "Hinjewadi to Mumbai Central taxi fare services offer pricing details for passengers traveling to Mumbai Central railway station. Vehicles are comfortable and suitable for long-distance travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, and hotels across Hinjewadi. Flexible booking options allow convenient ride reservations."
},
{
name: "Hinjewadi To Goregaon Taxi Fare",
description: "Hinjewadi to Goregaon taxi service provides reliable intercity transportation between Pune’s Hinjewadi area and Goregaon in Mumbai. Comfortable vehicles with professional drivers ensure safe highway travel via the expressway. Pickup services are available from IT parks, homes, and offices across Hinjewadi. Flexible booking options allow easy cab reservations."
},
{
name: "Hinjewadi To Dadar Cab Service",
description: "Hinjewadi to Dadar cab service offers dependable transportation between Hinjewadi and Dadar in Mumbai. Vehicles are well maintained and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, and IT parks in Hinjewadi. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable airport transportation for travelers heading to Mumbai Airport terminals. Vehicles offer comfortable seating and luggage space suitable for airport transfers. Professional drivers ensure punctual pickup and safe expressway travel. Flexible booking options allow advance airport ride reservations."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for highway journeys. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for expressway journeys. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow convenient ride reservations."
},
{
name: "Hinjewadi To Mumbai Airport Cab Charges",
description: "Hinjewadi to Mumbai Airport cab charges services provide transparent fare details for travelers planning airport transfers from Hinjewadi. Passengers can choose vehicles based on comfort and budget requirements. Professional drivers ensure safe driving and punctual pickup services across Hinjewadi. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Hinjewadi To Andheri Cabs",
description: "Hinjewadi to Andheri cabs provide reliable transportation between Pune’s IT hub and Andheri in Mumbai. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys. Pickup services are available from offices, homes, and tech parks in Hinjewadi. Flexible booking options allow convenient cab reservations."
},
{
name: "Hinjewadi To Thane Cab Fare",
description: "Hinjewadi to Thane cab fare services provide transparent pricing for passengers traveling between Hinjewadi and Thane city. Vehicles are comfortable and suitable for long-distance travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, and IT parks across Hinjewadi. Flexible booking options allow easy cab reservations."
},
{
name: "Hinjewadi To Virar Cab Fare",
description: "Hinjewadi to Virar cab service offers dependable transportation for travelers heading to Virar from Hinjewadi. Comfortable vehicles and experienced drivers ensure safe highway travel via the expressway. Pickup services are available from homes, offices, and hotels in Hinjewadi. Flexible booking options allow convenient ride reservations."
},
{
name: "Hinjewadi To Mumbai Innova Cab Fare",
description: "Hinjewadi to Mumbai Innova cab fare services provide premium SUV transportation pricing for travelers traveling between Hinjewadi and Mumbai. Innova vehicles offer spacious seating and smooth ride quality ideal for expressway journeys. Flexible booking options allow convenient ride reservations."
},
{
name: "7 Seater Innova On Rent in Pune",
description: "7 seater Innova on rent in Pune service offers spacious SUV transportation for family travel, corporate trips, and airport transfers. The Innova vehicle provides comfortable seating and luggage space suitable for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Pune. Flexible booking options allow convenient SUV rental."
},
{
name: "Innova Crysta Per Km Rate Pune",
description: "Innova Crysta per km rate Pune services provide transparent pricing for travelers hiring premium SUVs in Pune. The Innova Crysta offers luxurious interiors, spacious seating, and smooth highway travel suitable for long-distance journeys. Flexible booking options allow convenient car rental planning."
},
{
name: "Hinjewadi to Mumbai Velocity Cabs",
description: "Hinjewadi to Mumbai Velocity Cabs service offers dependable transportation for passengers traveling between Pune’s IT hub and Mumbai. Vehicles are well maintained and suitable for expressway travel with experienced drivers ensuring safe journeys. Flexible booking options allow easy cab reservations."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles with professional drivers ensure safe travel across Pune and nearby destinations. Flexible booking options allow convenient taxi reservations."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable intercity transportation between Pune and Mumbai via the expressway. Vehicles are comfortable and suitable for long-distance travel with experienced drivers ensuring safe journeys. Flexible booking options allow easy cab reservations."
},
{
name: "Corporate Cab in Hinjewadi",
description: "Corporate cab in Hinjewadi service offers reliable employee transportation solutions for IT companies and corporate offices in Hinjewadi. Comfortable vehicles with professional drivers ensure punctual pickup and safe journeys for corporate travel. Flexible booking options allow convenient corporate cab scheduling."
},
{
name: "Hinjewadi to Mumbai Cab",
description: "Hinjewadi to Mumbai cab service provides comfortable transportation between Pune’s IT hub and Mumbai city. Vehicles are well maintained and suitable for expressway travel with experienced drivers ensuring safe journeys. Flexible booking options allow convenient cab reservations."
},
{
name: "Hinjewadi to Mumbai Taxi",
description: "Hinjewadi to Mumbai taxi service offers dependable transportation with professional drivers and comfortable vehicles. Passengers can travel safely via the expressway with punctual pickup services from homes, offices, and IT parks in Hinjewadi. Flexible booking options allow easy taxi reservations."
},
{
name: "Hinjewadi to Mumbai Cab Service",
description: "Hinjewadi to Mumbai cab service provides reliable intercity transportation with comfortable vehicles and experienced drivers. Pickup services are available from homes, offices, and tech parks across Hinjewadi. Flexible booking options allow convenient ride reservations."
},
{
name: "Hinjewadi to Mumbai Taxi Service",
description: "Hinjewadi to Mumbai taxi service provides safe and comfortable transportation for travelers traveling between Hinjewadi and Mumbai. Vehicles are suitable for expressway travel with professional drivers ensuring safe journeys. Flexible booking options allow convenient taxi reservations."
},
{
name: "Hinjewadi to Mumbai Cab Booking",
description: "Hinjewadi to Mumbai cab booking service allows travelers to easily reserve taxis for intercity travel through online or phone booking. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys."
},
{
name: "Cab from Hinjewadi to Mumbai",
description: "Cab from Hinjewadi to Mumbai service provides reliable transportation between Pune’s Hinjewadi area and Mumbai city. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys. Flexible booking options allow convenient ride reservations."
}
],

tableData: [
["Hinjewadi To Borivali Taxi","Hinjewadi To Santacruz Taxi"],
["Hinjewadi To Andheri Taxi","Hinjewadi To Mumbai Airport Taxi"],
["Hinjewadi To International Airport Cab","Hinjewadi To Airport Fare"],
["Hinjewadi To Mumbai Drop Taxi Fare","Hinjewadi To Mumbai Central Taxi Fare"],
["Hinjewadi To Goregaon Taxi Fare","Hinjewadi To Dadar Cab Service"],
["Pune to Mumbai Airport Cab","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Hinjewadi To Mumbai Airport Cab Charges"],
["Hinjewadi To Andheri Cabs","Hinjewadi To Thane Cab Fare"],
["Hinjewadi To Virar Cab Fare","Hinjewadi To Mumbai Innova Cab Fare"],
["7 Seater Innova On Rent in Pune","Innova Crysta Per Km Rate Pune"],
["Hinjewadi to Mumbai Velocity Cabs","Cab Service in Pune"],
["Pune Mumbai Cab","Corporate Cab in Hinjewadi"],
["Hinjewadi to Mumbai Cab","Hinjewadi to Mumbai Taxi"],
["Hinjewadi to Mumbai Cab Service","Hinjewadi to Mumbai Taxi Service"],
["Hinjewadi to Mumbai Cab Booking","Cab from Hinjewadi to Mumbai"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Hinjewadi to Mumbai via the Mumbai Pune Expressway. Their knowledge of IT hub traffic routes and highway driving ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers clear and transparent pricing for Hinjewadi to Mumbai cab services. Customers receive complete fare details including toll charges and driver allowances before confirming their booking."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Hinjewadi to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or a late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable and relaxing travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Hinjewadi to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Hinjewadi",
    WhyChoosedescription: "We provide convenient pickup from homes, IT parks, offices, hotels, and residential societies across Hinjewadi Phase 1, Phase 2, and Phase 3 along with nearby areas like Wakad, Tathawade, and Marunji."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Hinjewadi to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Hinjewadi to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Hinjewadi to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Hinjewadi to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Hinjewadi to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Hinjewadi to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Hinjewadi and Mumbai." },
  { question: "Do you provide pickup from IT parks and offices?", answer: "Yes, our drivers provide pickup from IT parks, offices, homes, and hotels across Hinjewadi." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book Hinjewadi to Mumbai cab service online?", answer: "Yes, customers can easily book Hinjewadi to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and office travel hours." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshpande",
    feedback:
      "The Hinjewadi to Mumbai trip was very comfortable and well-managed. The cab was on time, the driver was professional, and the ride was smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Traveling from Hinjewadi to Mumbai was a great experience. The vehicle was clean, the journey was punctual, and everything felt safe and well-organized.",
    rating: 5
  }
];










































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hinjewadi to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Hinjewadi to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Innova Crysta for airport transfers, Borivali, Andheri, Santacruz, Dadar, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Hinjewadi to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};









  return (
    <div>
      <Helmet>
  <title>Hinjewadi to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Hinjewadi to Mumbai cab with Velocity Cabs. Affordable taxi service for one way, round trip & airport drop. Ertiga, Innova & Crysta cabs available for Borivali, Andheri, Dadar, Santacruz & more." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Hinjewaditomumbaicabs;